/**
 * @daily-puzzle/shared
 *
 * Shared types and contracts between client and server.
 */
// Enums
export { Status, AttemptResult, DayLabel } from './enums.js';
// Constants
export const MAX_ATTEMPTS = 3;
//# sourceMappingURL=index.js.map